import clsx from 'clsx'
import React from 'react'
import i18n from 'src/shared/i18n'

import {classes} from './CommentButton.styles'

type Props = {
  feedback?: string
  onClick: VoidFunction
}

const CommentButton: React.FC<Props> = ({feedback, onClick}) => {
  return (
    <div className={classes.button} data-e2e="feedback-comment-button" onClick={onClick}>
      <div className={clsx(classes.placeholder, feedback && classes.placeholderTop)}>
        {i18n.print('route_feedback')}
      </div>
      {feedback && <div className={classes.text}>{feedback}</div>}
    </div>
  )
}

export default CommentButton
